import React from 'react';
import { hot } from 'react-hot-loader';
import ButtonElement from '../../Elements/Button/Button';
import { cleanInternalLinks, camelCase } from '../../../utils/string';

const Button = ({ content = {}, attrs = {}, isManyButtons = false }) => {
	const variantClasses = [];
	const style = {};

	if (isManyButtons) variantClasses.push('button__multiple');
	if (attrs.outline) variantClasses.push('button__outline');
	if (attrs.fullWidth) variantClasses.push('button__fullWidth');
	if (attrs.width) variantClasses.push(`button__${attrs.width}`);
	if (attrs.className) variantClasses.push(`button_${attrs.className}`);
	if (attrs.backgroundColor) {
		style.backgroundColor = attrs.backgroundColor;
		style.borderColor = attrs.backgroundColor;
	}
	if (attrs.borderRadius) style.borderRadius = attrs.borderRadius.join(' ');
	if (attrs.textColor) {
		style.color = attrs.textColor;
		if (attrs.textColor === '#FFFFFF') style.fontWeight = '700';
	}
	if (content?.attrs?.style && content.attrs.style.indexOf(':') !== -1) {
		content.attrs.style.split(';').forEach((p) => {
			const [key, value] = p.split(':');
			style[camelCase(key)] = value;
		});
	}

	if (!content.rawText) return null;

	return (
		<ButtonElement type="link" location={cleanInternalLinks(content.attrs.href)} variantClasses={variantClasses} text={content.rawText} style={Object.keys(style).length > 0 ? style : null} />
	);
};

export default hot(module)(Button);
